<form
  [formGroup]="form"
  (ngSubmit)="onSubmitNotification()"
  #formRef="ngForm"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
>
  <!-- Card -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsedRegCategoryFilter ? 'false' : 'true'"
          (click)="isCollapsedRegCategoryFilter = !isCollapsedRegCategoryFilter"
          aria-controls="notifications"
        >
          <span class="fs-3">
            {{ 'configurationOptionModule.notifications' | translate }}
          </span>

          <i
            class="fa fa-fw"
            [ngClass]="
              isCollapsedRegCategoryFilter ? 'fa-chevron-down' : 'fa-chevron-up'
            "
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div
      *ngIf="!isCollapsedRegCategoryFilter"
      class="card-body"
      id="notifications"
    >
      <div class="mb-4">
        <fieldset>
          <legend class="form-label">
            {{ 'configurationOptionModule.notifications' | translate }}
            <i
              class="ms-2 fa fa-question-circle"
              role="button"
              tabindex="0"
              [tooltip]="
                'configurationOptionModule.notificationsTooltip' | translate
              "
            ></i>
          </legend>
          <div class="btn-group-segment">
            <input
              type="radio"
              class="btn-check"
              name="notifications"
              value="{{ true }}"
              (click)="patchValueForm('notifications', true)"
              id="notificationsbtnradio1"
              autocomplete="off"
              [checked]="form.value.notifications"
              aria-describedby="notificationsError"
            />
            <label class="btn" for="notificationsbtnradio1">
              {{ 'general.yes' | translate }}
            </label>

            <input
              type="radio"
              class="btn-check"
              name="notifications"
              id="notificationsbtnradio2"
              value="{{ false }}"
              (click)="patchValueForm('notifications', false)"
              autocomplete="off"
              [checked]="!form.value.notifications"
              aria-describedby="notificationsError"
            />
            <label class="btn" for="notificationsbtnradio2">
              {{ 'general.no' | translate }}
            </label>
          </div>
        </fieldset>

        <p
          class="invalid-feedback"
          role="alert"
          aria-atomic="true"
          id="notificationsError"
          *ngIf="
            form.controls.notifications.dirty &&
            form.controls.notifications.invalid
          "
        >
          <i
            role="img"
            class="fas fa-exclamation-circle"
            aria-hidden="true"
          ></i>
          {{ 'configurationOptionModule.notifications' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>
      <div class="mb-4">
        <fieldset [disabled]="!form.value.notifications">
          <legend class="form-label">
            {{ 'memberModule.notificationsNewsletters' | translate }}
            <i
              class="ms-2 fa fa-question-circle"
              role="button"
              tabindex="0"
              [tooltip]="
                'configurationOptionModule.notificationsNewslettersTooltip'
                  | translate
              "
            ></i>
          </legend>

          <div class="btn-group-segment">
            <input
              type="radio"
              class="btn-check"
              name="emailNewsletterAgreement"
              value="{{ true }}"
              (click)="patchValueForm('emailNewsletterAgreement', true)"
              id="emailNewsletterAgreementbtnradio1"
              autocomplete="off"
              [checked]="form.value.emailNewsletterAgreement"
              aria-describedby="emailNewsletterAgreementError"
            />
            <label class="btn" for="emailNewsletterAgreementbtnradio1">
              {{ 'general.yes' | translate }}
            </label>

            <input
              type="radio"
              class="btn-check"
              name="emailNewsletterAgreement"
              id="emailNewsletterAgreementbtnradio2"
              value="{{ false }}"
              (click)="patchValueForm('emailNewsletterAgreement', false)"
              autocomplete="off"
              [checked]="!form.value.emailNewsletterAgreement"
              aria-describedby="emailNewsletterAgreementError"
            />
            <label class="btn" for="emailNewsletterAgreementbtnradio2">
              {{ 'general.no' | translate }}
            </label>
          </div>
        </fieldset>
        <p
          class="invalid-feedback"
          role="alert"
          aria-atomic="true"
          id="emailNewsletterAgreementError"
          *ngIf="
            form.controls.emailNewsletterAgreement.dirty &&
            form.controls.emailNewsletterAgreement.invalid
          "
        >
          <i
            role="img"
            class="fas fa-exclamation-circle"
            aria-hidden="true"
          ></i>
          {{ 'memberModule.emailNewsletterAgreement' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>
      <div class="mb-4">
        <fieldset [disabled]="!form.value.notifications">
          <legend class="form-label">
            {{ 'memberModule.notificationsOffers' | translate }}
            <i
              class="ms-2 fa fa-question-circle"
              role="button"
              tabindex="0"
              [tooltip]="
                'configurationOptionModule.notificationsOffersTooltip'
                  | translate
              "
            ></i>
          </legend>

          <div class="btn-group-segment">
            <input
              type="radio"
              class="btn-check"
              name="emailOffersAgreement"
              value="{{ true }}"
              (click)="patchValueForm('emailOffersAgreement', true)"
              id="emailOffersAgreementbtnradio1"
              autocomplete="off"
              [checked]="form.value.emailOffersAgreement"
              aria-describedby="emailOffersAgreementError"
            />
            <label class="btn" for="emailOffersAgreementbtnradio1">
              {{ 'general.yes' | translate }}
            </label>

            <input
              type="radio"
              class="btn-check"
              name="emailOffersAgreement"
              id="emailOffersAgreementbtnradio2"
              value="{{ false }}"
              (click)="patchValueForm('emailOffersAgreement', false)"
              autocomplete="off"
              [checked]="!form.value.emailOffersAgreement"
              aria-describedby="emailOffersAgreementError"
            />
            <label class="btn" for="emailOffersAgreementbtnradio2">
              {{ 'general.no' | translate }}
            </label>
          </div>
        </fieldset>
        <p
          class="invalid-feedback"
          role="alert"
          aria-atomic="true"
          id="emailOffersAgreementError"
          *ngIf="
            form.controls.emailOffersAgreement.dirty &&
            form.controls.emailOffersAgreement.invalid
          "
        >
          <i
            role="img"
            class="fas fa-exclamation-circle"
            aria-hidden="true"
          ></i>
          {{ 'memberModule.notificationsOffers' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>

      <div class="d-flex justify-content-end">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
</form>
